export default __webpack_public_path__ + "static/media/Graph.ebdab688.svg";